<template>
  <div class="contractors-main-table__row">
    <div class="contractors-main-table__cell contractors-main-table__cell_index">
      {{ index + 1 }}
    </div>
    <div class="contractors-main-table__cell contractors-main-table__cell_name">
      {{ contractor.name }}
    </div>
    <div class="contractors-main-table__cell pointer" @click="$emit('edit-contractor', 1)">
      <UserInfo
        v-if="computedContact"
        :user="computedContact"
        class="contractors-main-table__user-info"
      />
      <Button
        v-else
        custom-color="blue"
        size="small"
        type="ghost"
        icon="plus"
        class="contractors__link-btn"
      >
        {{ $t('Add contacts') }}
      </Button>
    </div>
    <div
      :ref="getContractorWorksRef"
      class="contractors-main-table__cell pointer"
      @click="$emit('edit-contractor', 2)"
    >
      <div v-if="contractor.works && contractor.works.length" class="d-contents spacex-8">
        <Badge
          v-for="work in worksForShow"
          :key="work.id"
          color="grey"
          class="contractors-main-table__work-badge"
        >
          <span class="no-wrap">
            {{
              allWorksMap[work] ? `${allWorksMap[work].number}. ${allWorksMap[work].title}` : work
            }}
          </span>
        </Badge>
        <Badge
          v-if="contractor.works && contractor.works.length > countOfWorksForShow"
          color="grey"
        >
          +{{ contractor.works.length - countOfWorksForShow }}
        </Badge>
      </div>
      <Button
        v-else
        custom-color="blue"
        size="small"
        type="ghost"
        icon="plus"
        class="contractors__link-btn"
      >
        {{ $t('Add works') }}
      </Button>
    </div>
    <div class="contractors-main-table__cell">
      <Button
        v-if="contractor.tenders_count"
        custom-color="blue"
        size="small"
        type="ghost"
        class="contractors__link-btn"
        @click.native="$emit('edit-contractor', 3)"
      >
        {{ $tc('tender', contractor.tenders_count) }}
      </Button>
    </div>
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <div class="contractors-main-table__cell" v-bind="attrs" v-on="on">
          <Icon type="more-horizontal" size="20" />
        </div>
      </template>
      <DropdownMenu>
        <!--        <DropdownMenuElement left-icon="plus">-->
        <!--          {{ $t('Invite to tender') }}-->
        <!--        </DropdownMenuElement>-->
        <DropdownMenuElement left-icon="pencil" @click.native="$emit('edit-contractor')">
          {{ $t('Edit info') }}
        </DropdownMenuElement>
        <!--        <DropdownMenuElement left-icon="archive" color="error">-->
        <!--          {{ $t('Archive') }}-->
        <!--        </DropdownMenuElement>-->
      </DropdownMenu>
    </v-menu>
  </div>
</template>

<script>
  import { VMenu } from 'vuetify/lib';
  import Badge from '@/components/ui/Badge';
  import Icon from '@/components/ui/Icon';
  import DropdownMenu from '@/components/ui/dropdown-menu/DropdownMenu';
  import DropdownMenuElement from '@/components/ui/dropdown-menu/DropdownMenuElement';
  import UserInfo from '@/components/ui/UserInfo';
  import Button from '@/components/ui-v2/Button';
  import { mapState } from 'vuex';

  export default {
    name: 'ContractorsMainTableRow',
    components: { Button, UserInfo, DropdownMenuElement, DropdownMenu, Icon, Badge, VMenu },
    props: {
      contractor: {
        type: Object,
        required: true,
      },
      index: {
        type: Number,
        required: true,
      },
    },
    data() {
      return {
        countOfWorksForShow: 1,
      };
    },
    computed: {
      ...mapState('contractors', ['workGroups']),
      getContractorWorksRef() {
        return `contractors-work-cell-${this.contractor.id}`;
      },
      allWorksMap() {
        let worksMap = {};
        Object.values(this.workGroups).forEach((elem) => {
          worksMap = { ...worksMap, ...elem.works };
        });
        return worksMap;
      },
      worksForShow() {
        return this.contractor.works.slice(0, this.countOfWorksForShow);
      },
      computedContact() {
        return this.contractor?.contact || this.contractor?.contacts?.[0];
      },
    },
    methods: {
      computeCountOfWorks() {
        this.countOfWorksForShow = 1;
        const maxWidth = this.$refs[this.getContractorWorksRef].clientWidth;
        const CELL_PADDINGS = 24;
        const BADGE_PADDINGS = 16;
        const BADGE_MARGIN = 8;
        const LETTER_WIDTH = 8;
        const COUNT_OF_SPACES = 2;
        const widthOfCounterBadge = 48;
        let availableWidth = maxWidth - CELL_PADDINGS - widthOfCounterBadge;
        let counter = 0;
        for (let i = 0; i < this.contractor.works.length; i++) {
          let nextBadgeText = this.allWorksMap?.[this.contractor?.works?.[i]]?.title;
          let nextBadgeNumber = this.allWorksMap?.[this.contractor?.works?.[i]]?.number;
          const textLength = nextBadgeText.length * LETTER_WIDTH;
          const numberLength = nextBadgeNumber.toString().length * LETTER_WIDTH;
          const badgeWidth =
            textLength +
            numberLength +
            COUNT_OF_SPACES * LETTER_WIDTH +
            BADGE_PADDINGS +
            BADGE_MARGIN;
          if (availableWidth - badgeWidth > 0) {
            availableWidth -= badgeWidth;
            counter += 1;
          }
        }
        this.countOfWorksForShow = counter || 1;
      },
    },
    watch: {
      workGroups() {
        this.computeCountOfWorks();
      },
      contractor() {
        this.computeCountOfWorks();
      },
    },
    mounted() {
      window.addEventListener('resize', this.computeCountOfWorks);
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.computeCountOfWorks);
    },
  };
</script>
